<template>
  <div class="headall">
    <div id="header" class="flex_sw">
      <div class="header-left">
        <img class="header-logo" src="@/assets/images/index/logo.png" mode="aspectFill" @click="handleTo('/')" />
        <div class="header-left-list">
          <div class="header-left-item" v-for="item in headerArr" :key="item.id" @click="handleTo(item.url)">
            <div class="header-left-item-top"></div>
            <div class="header-left-item-title">{{ item.name }}</div>
            <div :class="['header-left-item-top', item.routrArr.includes(headroute) ? 'header-left-item-bot' : '']">
            </div>
          </div>
        </div>
      </div>
      <div class="a-static a-display">
        <div class="mk-nav-responsive-link" @click="handleH5">
          <div class="mk-css-icon-menu">
            <div class="mk-css-icon-menu-line-1"></div>
            <div class="mk-css-icon-menu-line-2"></div>
            <div class="mk-css-icon-menu-line-3"></div>
          </div>
        </div>
      </div>
      <div class="header-right">
        <div v-if="!token" class="header-right-btn flex_center" @click="handleTo('/login')">
          登录
        </div>
        <div v-if="!token" class="header-right-btn flex_center header-right-btn2" @click="handleTo('/register')">
          注册
        </div>
        <div v-if="token" class="header-right-login">
          <el-dropdown trigger="hover">
            <span class="el-dropdown-link">
              <div class="header-right-login-avatar flex_center">
                <img :src="userInfo.avatar" alt="" />
                <div>{{ userInfo.name }}</div>
                <i class="el-icon-arrow-down"></i>
              </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="header-right-login-avatar2 flex_center" @click="handleTo('/myAccountSecurity')">
                  <img :src="userInfo.avatar" alt="" />
                  <div>{{ userInfo.name }}</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="header-right-login-item flex_sw" @click="handleTo('/myWrongQuestion')">
                  <div class="header-right-login-item-icon">
                    <img src="@/assets/images/icon/x1.png" alt="" />
                    <div>错题集</div>
                  </div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="header-right-login-item flex_sw" @click="handleTo('/myRecord')">
                  <div class="header-right-login-item-icon">
                    <img src="@/assets/images/icon/x2.png" alt="" />
                    <div>刷题记录</div>
                  </div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="header-right-login-item flex_sw" @click="handleTo('/myAccountSecurity')">
                  <div class="header-right-login-item-icon">
                    <img src="@/assets/images/icon/x3.png" alt="" />
                    <div>账号安全</div>
                  </div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="header-right-login-item flex_sw" @click="handleTo('/myCertification')">
                  <div class="header-right-login-item-icon">
                    <img src="@/assets/images/icon/x4.png" alt="" />
                    <div>实名认证</div>
                  </div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="header-right-login-avatar3 flex_center" @click="handleLogout">
                  <img src="@/assets/images/icon/x5.png" alt="" />
                  <div>退出登录</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- <div class="autnav">
      <ul class="layui-nav layui-nav-tree">
        <li class="layui-nav-item" v-for="item in headerArr" :key="item.id">
          <a href="javascript:;" v-if="item.child.length == 0" @click.stop="handleTo(item)">{{ languageZh == "cn" ?
            item.name : item.name_en }}</a>
          <a href="javascript:;" v-else>{{
            languageZh == "cn" ? item.name : item.name_en
          }}</a>
          <dl class="layui-nav-child" v-if="item.child.length > 0">
            <a href="javascript:;" v-for="items in item.child" :key="items.id"
              :class="[items.id == navChildId ? 'layui-nav-child-ac' : '']" @click.stop="handleTo(items)">{{ languageZh
                == "cn" ? items.name : items.name_en }}</a>
          </dl>
        </li>
      </ul>
    </div> -->

    </div>

    <div class="header2">
      <div class="a-static a-display">
        <div class="mk-nav-responsive-link">
          <div class="mk-css-icon-menu" @click="handleH5">
            <div class="mk-css-icon-menu-line-1"></div>
            <div class="mk-css-icon-menu-line-2"></div>
            <div class="mk-css-icon-menu-line-3"></div>
          </div>
        </div>
      </div>
      <div class="header_c">
        <img class="header-logo" src="@/assets/images/index/logo.png" mode="aspectFill" @click="handleTo('/')" />
      </div>
      <div class="header_r">
        <div v-if="!token" class="header-right-btn flex_center" @click="handleTo('/login')">
          登录
        </div>
        <div v-if="!token" class="header-right-btn flex_center header-right-btn2" @click="handleTo('/register')">
          注册
        </div>
        <div v-if="token" class="header-right-login">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              <div class="header-right-login-avatar flex_center">
                <img :src="userInfo.avatar" alt="" />
                <div>{{ userInfo.name }}</div>
                <i class="el-icon-arrow-down"></i>
              </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item>
                <div class="header-right-login-avatar2 flex_center" @click="handleTo('/myAccountSecurity')">
                  <img :src=" userInfo.avatar" alt="" />
                  <div>{{ userInfo.name }}</div>
                </div>
              </el-dropdown-item> -->
              <el-dropdown-item>
                <div class="header-right-login-item flex_sw" @click="handleTo('/myWrongQuestion')">
                  <div class="header-right-login-item-icon">
                    <!-- <img src="@/assets/images/icon/x1.png" alt="" /> -->
                    <div>错题集</div>
                  </div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="header-right-login-item flex_sw" @click="handleTo('/myRecord')">
                  <div class="header-right-login-item-icon">
                    <!-- <img src="@/assets/images/icon/x2.png" alt="" /> -->
                    <div>刷题记录</div>
                  </div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="header-right-login-item flex_sw" @click="handleTo('/myAccountSecurity')">
                  <div class="header-right-login-item-icon">
                    <!-- <img src="@/assets/images/icon/x3.png" alt="" /> -->
                    <div>账号安全</div>
                  </div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="header-right-login-item flex_sw" @click="handleTo('/myCertification')">
                  <div class="header-right-login-item-icon">
                    <!-- <img src="@/assets/images/icon/x4.png" alt="" /> -->
                    <div>实名认证</div>
                  </div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="header-right-login-item flex_center" @click="handleLogout">
                  <div class="header-right-login-item-icon">
                    <!-- <img src="@/assets/images/icon/x4.png" alt="" /> -->
                    <div>退出登录</div>
                  </div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="header_maskbox" v-show="show" @click.stop="handleH5">
        <div class="header_mask" @click.stop>
          <el-menu :default-active="defaultmenu" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
            <el-menu-item index="1" @click="handleTo('/')">
              <span slot="title">首页</span>
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title" @click="handleTo('/aboutContent')">
                <span>关于长理电力</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="2-1" @click="handleTo('/aboutContent')">长理简介</el-menu-item>
                <el-menu-item index="2-2" @click="handleTo('/aboutHonor')">校园环境</el-menu-item>
                <el-menu-item index="2-2" @click="handleTo('/aboutCorporate')">学员风采</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="3" @click="handleTo('/recordedLessons')">
              <span slot="title">录播课</span>
            </el-menu-item>
            <el-menu-item index="4" @click="handleTo('/questionBank')">
              <span slot="title">题库</span>
            </el-menu-item>
            <el-menu-item index="5" @click="handleTo('/exam')">
              <span slot="title">真题模考</span>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      urls: this.imgurl,

      centerDialogVisible: false,
      headroute: '',
      headerArr: [
        {
          id: 1,
          name: "首页",
          url: "/",
          routrArr: ['/']
        },
        {
          id: 2,
          name: "关于长理电力",
          url: "/aboutContent",
          routrArr: ['/aboutContent', '/aboutHonor', '/aboutCorporate']
        },
        {
          id: 3,
          name: "录播课",
          url: "/recordedLessons",
          routrArr: ['/recordedLessons', '/recordVideo']
        },
        {
          id: 4,
          name: "题库",
          url: "/questionBank",
          routrArr: ['/questionBank', '/questionBankList', '/questionDetails', '/QuestionResult']
        },
        {
          id: 5,
          name: "真题模考",
          url: "/exam",
          routrArr: ['/exam', '/examDetail', '/examResult']
        },
      ],
      token: "",
      defaultmenu: 1,

      userInfo: {},
      show: false
    };
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.userIndex()
    } else {
      this.userInfo = {}
    }
  },
  methods: {
    async userIndex() {
      let res = await this.$api.userIndex()
      if (res.code == 1) {
        res.data.avatar = this.urls + res.data.avatar
        this.userInfo = res.data
      }
    },
    handleH5() {
      $(".mk-nav-responsive-link").toggleClass("dashboard-active");
      if ($(".mk-nav-responsive-link").hasClass("dashboard-active")) {
        $(".h5-nav").css({ display: "block" });
        $(".a-static").css({ "box-shadow": "none" });
      } else {
        $(".h5-nav").css({ display: "none" });
        // $(".a-static").css({ "box-shadow": "0 1px 8px rgba(126, 0, 0, 0.36)" });
      }
      this.show = !this.show
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleTo(url) {
      if (this.show) {
        this.handleH5()
      }
      this.$router.push(url);
    },
    handleLogout() {
      this.$parent.centerDialogVisible = true;
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.token = localStorage.getItem("token");
        if (localStorage.getItem("token")) {
          this.userIndex()
        } else {
          this.userInfo = {}
        }
        this.headroute = val.path
        this.headerArr.forEach(item => {
          if (item.routrArr.includes(this.headroute)) {
            this.defaultmenu = item.id.toString()
          }
        })
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="less">
.el-dropdown-menu {
  padding: 0;
}

.el-dropdown-menu__item,
.el-menu-item {
  padding: 0;
}
</style>
<style lang="less" scoped>
#header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 0.417rem;
  padding: 0 0.781rem;
  background-color: #fff;

  .header-left {
    display: flex;
    align-items: center;

    .header-logo {
      width: 1.125rem;
      height: 0.313rem;
      margin-right: 0.745rem;
      cursor: pointer;
    }

    .header-left-list {
      display: flex;
      align-items: center;

      .header-left-item {
        font-size: 0.094rem;
        color: #333;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 0.307rem;
        cursor: pointer;

        .header-left-item-top {
          width: 16px;
          height: 3px;
        }

        .header-left-item-title {
          margin: 8px 0;
        }

        .header-left-item-bot {
          background-color: #0d4987;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
  }
}

.header-right-btn {
  width: 0.573rem;
  height: 0.229rem;
  background-color: #f0f1f6;
  border-radius: 0.031rem;
  font-size: 0.083rem;
  color: #333;
  cursor: pointer;
}

.header-right-btn2 {
  background-color: #0d4987;
  color: #fff;
  margin-left: 10px;
}

.header-right-login {
  .header-right-login-avatar {
    font-size: 0.094rem;

    img {
      width: 0.214rem;
      height: 0.214rem;
      margin-right: 0.073rem;
      border-radius: 50%;
    }

    i {
      margin-left: 0.047rem;
    }
  }
}

.header-right-login-avatar2 {
  width: 1.146rem;
  height: 0.469rem;
  font-size: 0.094rem;
  border-bottom: 1px solid #e5e6eb;

  img {
    width: 0.214rem;
    height: 0.214rem;
    border-radius: 50%;
    margin-right: 0.073rem;
  }
}

.header-right-login-avatar3 {
  font-size: 0.078rem;
  height: 0.26rem;
  border-top: 1px solid #e5e6eb;

  img {
    width: 0.068rem;
    height: 0.068rem;
    margin-right: 0.031rem;
  }
}

.header-right-login-item {
  font-size: 0.078rem;
  height: 0.266rem;
  padding: 0 0.146rem 0 0.068rem;

  .header-right-login-item-icon {
    display: flex;
    align-items: center;
    font-size: 0.078rem;

    img {
      width: 0.068rem;
      height: 0.068rem;
      margin-right: 0.031rem;
    }
  }
}

.h5-nav {
  display: none;
}

.a-display {
  // display: none;
}

.header2 {
  display: none;
}

// @media (max-width: 860px) {
//   .a-display {
//     display: flex;
//     align-items: center;
//   }

//   #header {
//     height: 64px;
//     padding: 0 20px;

//     .header-left {
//       .header-logo {
//         width: 140px;
//         height: auto;
//       }

//       .header-left-list {
//         display: none;
//       }
//     }

//     .header-right {
//       display: none;
//     }

//     .language {
//       margin-right: 20px;
//       position: relative;
//       cursor: pointer;

//       &:hover {
//         .language_posi {
//           display: block;
//         }
//       }

//       .language_img {
//         width: 32px;
//         height: 32px;
//         background-color: #f0f0f0;
//         border-radius: 50%;

//         img {
//           width: 18px;
//           height: 18px;
//         }
//       }

//       .language_posi {
//         position: absolute;
//         bottom: 0;
//         left: 50%;
//         transform: translate(-50%, 100%);
//         display: none;

//         .language_posi_abs {
//           width: 120px;
//           border-radius: 6px;
//           background-color: rgba(255, 255, 255, 0.8);
//           padding-top: 16px;

//           .language_posi_abs_item {
//             height: 36px;
//             font-size: 14px;
//             color: #666;
//             text-align: center;
//             line-height: 36px;

//             &:hover {
//               background-color: #0d4987;
//               color: #fff;
//             }

//             &:first-child {
//               border-bottom: 1px solid rgba(0, 0, 0, 0.06);
//             }
//           }

//           .language_posi_abs_item_active {
//             background-color: #0d4987;
//             color: #fff;
//           }
//         }
//       }
//     }

//     .mk-nav-responsive-link {
//       transition: all 0.15s ease-in-out;
//       -webkit-perspective: 1000;
//     }

//     .mk-css-icon-close div,
//     .mk-css-icon-menu div {
//       background-color: #0d4987;
//     }

//     .mk-css-icon-close div,
//     .mk-css-icon-menu div {
//       height: 3px;
//       margin-bottom: 3px;
//       border-radius: 3px;
//       display: block;
//       position: relative;
//     }

//     .mk-css-icon-menu-line-1,
//     .mk-css-icon-menu-line-3 {
//       transition: all 0.2s ease;
//     }

//     .mk-css-icon-menu-line-2 {
//       transition: opacity 0.1s ease;
//     }

//     .mk-css-icon-close,
//     .mk-css-icon-menu {
//       width: 18px;
//       height: 18px;
//       -webkit-transform: translateZ(0);
//       transform: translateZ(0);
//     }

//     .mk-nav-responsive-link {
//       cursor: pointer;
//       padding: 10px;
//       transition: all 0.15s ease-in-out;
//       -webkit-perspective: 1000;
//     }

//     .dashboard-active .mk-css-icon-menu-line-1,
//     .is-active .mk-css-icon-menu-line-1 {
//       transform: rotate3d(0, 0, 1, 45deg);
//       top: 6px;
//     }

//     .dashboard-active .mk-css-icon-menu-line-2,
//     .is-active .mk-css-icon-menu-line-2 {
//       opacity: 0;
//     }

//     .dashboard-active .mk-css-icon-menu-line-3,
//     .is-active .mk-css-icon-menu-line-3 {
//       transform: rotate3d(0, 0, 1, -45deg);
//       top: -6px;
//     }

//     .h5-nav {
//       width: 100%;
//       height: 100%;
//       position: fixed;
//       top: 64px;
//       left: 0;
//       z-index: 201;
//       // padding-top: 64px;
//       box-sizing: border-box;
//     }

//     .h5-nav .layui-nav {
//       background-color: #fff;
//     }

//     .h5-nav .layui-nav.layui-nav-tree {
//       width: 100%;
//     }

//     .h5-nav .layui-nav-tree .layui-nav-item {
//       background-color: #fff;
//     }

//     .h5-nav .layui-nav-tree .layui-nav-item a {
//       color: #444;
//       font-weight: bold;
//       font-size: 13px;
//       background-color: #fff;
//       border-bottom: 1px solid rgba(128, 128, 128, 0.2);
//       display: flex;
//       align-items: center;
//     }

//     .h5-nav .layui-nav-itemed>a,
//     .h5-nav .layui-nav-tree .layui-nav-title a,
//     .h5-nav .layui-nav-tree .layui-nav-title a:hover {
//       color: #444 !important;
//     }

//     .h5-nav .layui-nav-tree .layui-nav-child {
//       background-color: #fff;
//       padding: 0;
//     }

//     .h5-nav .layui-nav .layui-nav-item a:hover,
//     .h5-nav .layui-nav .layui-this a {
//       color: #444;
//       background-color: rgba(0, 0, 0, 0.03);
//     }

//     .h5-nav .layui-nav .layui-nav-child a:hover {
//       color: #0d4987 !important;
//       background-color: #fff !important;
//     }

//     .h5-nav .layui-nav .layui-nav-child-ac {
//       color: #0d4987 !important;
//       background-color: #fff !important;
//     }

//     .h5-nav .layui-nav-tree .layui-nav-bar {
//       display: none;
//     }

//     .h5-nav .layui-nav-tree .layui-nav-child a {
//       border-bottom: none;
//       font-size: 12px;
//       font-weight: normal;
//     }

//     .h5-nav .search_from {
//       padding: 10px;
//       box-sizing: border-box;
//       background-color: #fff;
//     }

//     .h5-nav .search_from form {
//       position: relative;
//     }

//     .h5-nav .search_from_tips {
//       font-size: 16px;
//       margin-bottom: 20px;
//       font-size: 16px;
//       color: #666666;
//       text-align: center;
//     }

//     .h5-nav .text-input {
//       font-size: 13px;
//       color: #767676;
//       margin: 0;
//       padding: 12px 28px 12px 15px;
//       width: 100%;
//       border: 2px solid rgba(0, 0, 0, 0.12);
//       background-color: #fdfdfd;
//       box-sizing: border-box;
//     }

//     .h5-nav .search_from form i {
//       position: absolute;
//       top: 13px;
//       right: 14px;
//       opacity: 0.4;
//     }

//     .h5-nav .search_from form i .search-button {
//       position: absolute;
//       top: 0;
//       left: 0;
//       display: block;
//       width: 100%;
//       height: 100%;
//       outline: 0;
//       border: none;
//       background-color: transparent;
//       cursor: pointer;
//     }
//   }

//   .autnav {
//     position: absolute;
//     top: 64px;
//     left: 0;
//   }
// }

@media (max-width: 860px) {
  #header {
    display: none;
  }

  .header2 {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 64px;
    padding: 0 4vw;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .mk-nav-responsive-link {
      transition: all 0.15s ease-in-out;
      -webkit-perspective: 1000;
    }

    .mk-css-icon-close div,
    .mk-css-icon-menu div {
      background-color: #0d4987;
    }

    .mk-css-icon-close div,
    .mk-css-icon-menu div {
      height: 3px;
      margin-bottom: 3px;
      border-radius: 3px;
      display: block;
      position: relative;
    }

    .mk-css-icon-menu-line-1,
    .mk-css-icon-menu-line-3 {
      transition: all 0.2s ease;
    }

    .mk-css-icon-menu-line-2 {
      transition: opacity 0.1s ease;
    }

    .mk-css-icon-close,
    .mk-css-icon-menu {
      width: 18px;
      height: 18px;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }

    .mk-nav-responsive-link {
      cursor: pointer;
      padding: 10px;
      transition: all 0.15s ease-in-out;
      -webkit-perspective: 1000;
    }

    .dashboard-active .mk-css-icon-menu-line-1,
    .is-active .mk-css-icon-menu-line-1 {
      transform: rotate3d(0, 0, 1, 45deg);
      top: 6px;
    }

    .dashboard-active .mk-css-icon-menu-line-2,
    .is-active .mk-css-icon-menu-line-2 {
      opacity: 0;
    }

    .dashboard-active .mk-css-icon-menu-line-3,
    .is-active .mk-css-icon-menu-line-3 {
      transform: rotate3d(0, 0, 1, -45deg);
      top: -6px;
    }

    .header_c {
      width: 28.8vw;
      height: auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .header_r {
      display: flex;
      align-items: center;

      .header-right-btn {
        width: auto;
        height: auto;
        font-size: 15px;
        border-radius: 5px;
        padding: 5px 15px;
      }

      .header-right-login {
        .header-right-login-avatar {
          font-size: 16px;

          img {
            width: 6.933vw;
            height: 6.933vw;
            margin-right: .073rem;
            border-radius: 50%;
          }

          i {
            margin-left: .047rem;
          }
        }
      }

      // .header-right-login-avatar2 {
      //   width: 1.146rem;
      //   height: 0.469rem;
      //   font-size: 0.094rem;
      //   border-bottom: 1px solid #e5e6eb;

      //   img {
      //     width: 0.214rem;
      //     height: 0.214rem;
      //     border-radius: 50%;
      //     margin-right: 0.073rem;
      //   }
      // }

      // .header-right-login-avatar3 {
      //   font-size: 0.078rem;
      //   height: 0.26rem;
      //   border-top: 1px solid #e5e6eb;

      //   img {
      //     width: 0.068rem;
      //     height: 0.068rem;
      //     margin-right: 0.031rem;
      //   }
      // }
    }
  }

  .header_maskbox {
    width: 100%;
    height: calc(100vh - 64px);
    background-color: rgba(0, 0, 0, 0.5);
    padding-right: 29.867vw;
    position: absolute;
    top: 64px;
    left: 0;

    .header_mask {
      width: 100%;
      height: 100%;
      background-color: #fff;
    }
  }

  .header-right-login-item {
    font-size: 3.733vw;
    height: 13.067vw;
    padding: 0 3.6vw 0 5.2vw;

    .header-right-login-item-icon {
      display: flex;
      align-items: center;
      font-size: 5.067vw;

      img {
        width: 0.068rem;
        height: 0.068rem;
        margin-right: 0.031rem;
      }
    }
  }
}
</style>